import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fip-data-placeholder',
  templateUrl: './data-placeholder.component.html',
  styleUrls: ['./data-placeholder.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DataPlaceholderComponent {
  public icon = input<string>('search');
}
